<template>
    <div>
        <statistics-row v-for="(row, index) in rows" 
            :key="`${row.name}-${index}`"
            :row="row"
        />
    </div>
</template>

<script>

import StatisticsRow from './StatisticsRow.vue';

export default {
    name: 'page',
    components: {
        StatisticsRow
    },
    computed: {
        //Chunk data into arrays with a max length.
        rows() {
            const chunk = (array, size) => {
                var results = [];
    
                while (array.length) {
                    results.push(array.splice(0, size));
                }
                
                return results;
            }

            return chunk(this.data, 4);
        }
    },
    props: {
        data: {
            type: Array,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped src="./Style/statistics-page.scss">

</style>